/**
 * Resource that represents an Inventory Item.
 *
 * @name InventoryItem
 * @class
 * @augments TmrResource
 */
function InventoryItemFactory(TmrApi, TmrResource, Product, Zone) {
  'ngInject'
  let referencedProperties = [
    // inventoryItem.product property will be instantiated as a Product resource
    { property: 'product', resource: Product },
    // inventoryItem.zone property will be instantiated as a Zone resource
    { property: 'zone', resource: Zone },
  ]

  let InventoryItem = TmrResource('InventoryItem', {}, referencedProperties)

  /**
   * Override default label property.
   *
   * @method InventoryItem#getLabelProperty
   */
  InventoryItem.getLabelProperty = InventoryItem.prototype.$getLabelProperty =
    () => 'upc'

  return InventoryItem
}

export const factory = ['InventoryItem', InventoryItemFactory]
